import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#066542",
      d: "M18.5 10a8.5 8.5 0 1 0-17 0 8.5 8.5 0 0 0 17 0m1.5 0c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#066542",
      d: "M5.961 5.961a.75.75 0 0 1 1.06 0l7.018 7.018a.75.75 0 0 1-1.06 1.06L5.96 7.022a.75.75 0 0 1 0-1.06"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#066542",
      d: "M12.979 5.961a.75.75 0 0 1 1.06 1.06L7.022 14.04a.75.75 0 0 1-1.06-1.06z"
    }, null, -1)
  ]))]))
}
export default { render: render }